module.exports = __webpack_public_path__ + "static/media/badPackaging1.120142f9.png";